import { PageTypeSuffix } from '@/constants'
import type { Product } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'

interface BreadcrumbType {
  data: Product
  translateText?: string
}

const Breadcrumb = ({ data, translateText }: BreadcrumbType) => {
  return (
    <div className='breadCrumb'>
      <ul className='flex list-none items-center gap-1 text-base text-blue'>
        <li>
          <Link href='/' className='home block text-blue'>
            {translateText || 'Trang chủ'}
          </Link>
        </li>
        <li className='divider'>{'>'}</li>
        {data && data?.cat ? (
          <li>
            <Link
              href={`/${
                getTranslate(data?.cat?.slugs.value) + PageTypeSuffix.CATEGORY
              }`}
              className='block text-blue'
            >
              {getTranslate(data?.cat?.name)}
            </Link>
          </li>
        ) : (
          ''
        )}
        <li className='divider'>{'>'}</li>
        {data && data?.cat ? (
          <li>
            <Link
              href={`/${getTranslate(data?.slugs.value)}${data?.slugs.postfix}`}
              className='block text-blue'
            >
              {getTranslate(data?.name)}
            </Link>
          </li>
        ) : (
          ''
        )}
      </ul>
    </div>
  )
}
export default Breadcrumb
